<template>
  <div
    class="minimart-admin"
    v-shortkey="['meta', '\\']"
    @shortkey="isAdminDrawerMini = !isAdminDrawerMini"
  >
    <AdminNavBar />

    <v-main>
      <!-- <v-container class="pb-5"> -->
      <!-- <transition name="fade" mode="out-in" appear> -->
      <div class="px-0">
        <v-col cols="12" class="px-0 pb-3">
          <slot />
          <router-view :key="$route.name" />
        </v-col>
      </div>
      <!-- </transition> -->
      <!-- </v-container> -->
      <!-- <AdminHelpButton /> -->
    </v-main>
    <v-snackbar
      :value="showSessionCountdown && !!expiryMessage"
      :timeout="-1"
      color="black"
    >
      <div class="text-h6">{{ expiryMessage }}</div>
    </v-snackbar>
  </div>
</template>

<script>
import AdminNavBar from '@/components/AdminNavBar'
// import AdminHelpButton from '@/components/AdminHelpButton'
import { mapFields } from 'vuex-map-fields'
import { mapGetters, mapActions } from 'vuex'
import fullstory from '@/plugins/fullstory'

export default {
  name: 'AdminLayout',
  components: {
    AdminNavBar,
    // AdminHelpButton
  },
  props: {
    layout: String,
  },
  data: () => ({
    validateSessionInterval: null,
    updateExpiryMessageInterval: null,
    expiryMessage: '',
    validationPeriodInSeconds: 30,
  }),
  async created() {
    // await this.validateSession()
    if (!this.validateSessionInterval) {
      this.validateSessionInterval = setInterval(
        this.validateSession,
        this.validationPeriodInSeconds * 1000
      )
    }
    if (!this.updateExpiryMessageInterval) {
      this.updateExpiryMessageInterval = setInterval(
        this.updateExpiryMessage,
        1000
      )
    }
  },
  computed: {
    ...mapFields('admin', ['isAdminDrawerMini']),
    ...mapGetters('auth', [
      'getSessionExpiryInSeconds',
      'getSessionExpiryVerbal',
      'isExpired',
      'showSessionCountdown',
    ]),
  },
  methods: {
    ...mapActions('auth', ['validateSession']),
    updateExpiryMessage() {
      this.expiryMessage = `Logging out in ${this.getSessionExpiryVerbal}`
    }, // updateExpiryMessage
  },
  mounted() {
    fullstory.init()
  },
  beforeDestroy() {
    clearInterval(this.validateSessionInterval)
    clearInterval(this.updateExpiryMessageInterval)
  },
}
</script>
